import { Component, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';

import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaDialogComponent } from '@priva/components/dialog-simple';
import { PrivaLocalizationModule } from '@priva/localization';

import { ScannedCode } from 'app/features/scan-flow/models';
import { closeDialog } from 'app/state/app-state/app-state.actions';
import { removeScannedCodeFromFlow } from 'app/state/scan-flow/scan-flow.actions';

@Component({
    selector: 'app-row-status-select-dialog',
    templateUrl: './scanned-container-dialog.component.html',
    styleUrl: './scanned-container-dialog.component.scss',
    imports: [PrivaDialogComponent, PrivaButtonComponent, PrivaLocalizationModule],
})
export class ScannedContainerDialogComponent {
    private store = inject(Store);

    onDialogClosedAction: Action | undefined;
    scannedCode: ScannedCode | undefined;
    title = '';

    closeDialog() {
        this.store.dispatch(closeDialog());
        if (this.onDialogClosedAction) this.store.dispatch(this.onDialogClosedAction);
    }

    removeContainer() {
        if (this.scannedCode?.code) {
            this.store.dispatch(removeScannedCodeFromFlow({ code: this.scannedCode.code }));
        }
        this.closeDialog();
    }
}
